import { useSearchParams } from "react-router-dom";

export const useSchemaEditor = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const schemaType = searchParams.get("schemaEditor");

  const toggleSchemaEditor = () => {
    setSearchParams((prev) => {
      const schemaEditor = prev.get("schemaEditor");

      if (!schemaEditor) {
        prev.set("schemaEditor", "true");
      } else {
        prev.delete("schemaEditor");
      }
      return prev;
    });
  };
  return [schemaType, toggleSchemaEditor] as const;
};
